module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('i', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Fm04"
    }
  }, [_vm._v("PROLOGUE")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Part01"
    }
  }, [_c('b', [_vm._v("PART ONE")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Part01"
    }
  }, [_c('b', [_vm._v("DESCENT INTO DARKNESS")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01"
    }
  }, [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01"
    }
  }, [_vm._v("Blue Eyes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liquid Confidence")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dart Boards")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dashed Hopes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABV")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seeking Support")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blind Man’s Bluff")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shattered Beauty")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Faith")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brave New World")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Angle")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Les")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wardrobe Madness")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lost and Found")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rugged Ruger")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pencil Man")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bent Knees")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bowery")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART TWO")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("AMAZING GRACE")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angels Among Us")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blind Injustice")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Random Acts of Kindness")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bumper Cars")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Christmas Present")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Au Revoir, Ruger")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soufflé and Elias")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossing Bridges")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Itchy Feet")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheryl’s Prayer")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Last Kiss")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Focus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snowfall")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Yellow Cab")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEVIN TODAY")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("APPENDIX A")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEVIN’S JOURNAL")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("APPENDIX B")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROLOGUE -"), _c('br'), _vm._v("EXCERPT FROM INFLECTION POINT")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHORS")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef5dd028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Contents.vue
// module id = 87
// module chunks = 0